export default __webpack_public_path__ + "static/media/ledger.2c3347bb.svg";